import React from "react"
import clsx from "clsx"
import FormBuilderErrors from "../FormBuilderErrors";

class FormBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        {this.renderGeneralForm()}
      </div>
    )
  }

  renderErrors() {
    var errors = FormBuilderErrors.generalErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }


  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('title')}*`}</label>
              <input
                id="name" 
                type="text" 
                name="title" 
                className={this.renderFieldClasses('title')}
                value={this.props.title || ''} 
                onChange={this.props.onChangeTextField}/>
              {this.renderFieldErrors("title")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("status")}</label>
              <br />
              <select
                id="status"
                name="form[status]"
                value={this.props.status || ""}
                onChange={this.props.onChangeStatus}
                className={this.renderFieldClasses("status", false)}
              >
                <option value="enabled">{I18n.t("enabled")}</option>
                <option value="disabled">{I18n.t("Disabled")}</option>
              </select>
              {this.renderFieldErrors("status")}
            </div>
          </div>
      
        </div>
        <div className="row">
          { this.props.form_type == 'document' 
            ? null
            :
              <div className="col-md-6">
                <div className="form-group">
                  <label>{I18n.t('description')}</label>
                  <textarea
                    id="name" 
                    type="text" 
                    name="description" 
                    rows={7}
                    className="form-control"
                    value={this.props.description || ''} 
                    onChange={this.props.onChangeTextField} 
                  />
                </div>
              </div>
          }

        </div>
      </div>
    )
  }
  
}

export default FormBuilderGeneral